import DOM from '@common/DOM/DOM'

import { ECanvasEvent } from './definitions'

/**
 * Canvason történő animáció szüneteltetése.
 * @param canvas   - Canvas.
 * @param isHidden - El is akarjuk rejteni?
 */
export default function pauseCanvas (canvas: HTMLCanvasElement, isHidden = false): void {
  DOM.dispatch(canvas, ECanvasEvent.Pause)

  if (isHidden) {
    canvas.style.visibility = 'hidden'
  }
}
